<template>
    <div class="titulo">
        <div class="margem container">
            <div class="m-icone direita"><button
                    @click="$router.push({ name: 'visualizacaoOsTablets', params: { id: 'criar' } })"
                    class="acao-secundaria">Adicionar</button>
            </div>
            <div class="m-icone direita">
                <div class="pesquisa">
                    <input type="text" placeholder="Pesquisar" v-model="search" />
                    <a disabled class="icone-pesquisa"></a>
                </div>
            </div>
            <h2>Ordens de Serviço Tablets</h2>
        </div>
    </div>
    <div class="margem container">
        <div class="bloco margem">
            <table class="tabela">
                <tbody>
                    <tr>
                        <th>
                            Código
                        </th>
                        <th> 
                            Cliente
                        </th>
                        <th>
                            Descrição
                        </th>
                        <th>
                            Operadora
                        </th>
                        <th>
                            Quantidade
                        </th>
                        <th>
                            Data da Criação
                        </th>
                        <th>
                            Fim Previsto
                        </th>
                        <th>
                            Prazo
                        </th>
                        <th>
                            Status
                        </th>
                        <th></th>
                    </tr>
                    <tr @click="verOs(os.id)" v-for="os in listaOS" :key="os.id">
                        <td>{{ os.codigo }}</td>
                        <td>{{ os.cliente?.nome }}</td>
                        <td>{{ os.descricao }}</td>
                        <td>{{ os.operadora?.nome }}</td>
                        <td>{{ os.qtd }}</td>
                        <td>{{ formatarData(os.created_at) }}</td>
                        <td>{{ formatarData(os.fim_previsto) }}</td>
                        <td>
                            <span class="chip" style="font-size: 14px; white-space: nowrap;"
                                :class="diasParaFim(os.status, os.fim_previsto).cor">
                                {{ diasParaFim(os.status, os.fim_previsto).mensagem }}
                            </span>
                        </td>
                        <td>
                            <div class="alinha-v alinha-centro">
                                <span style="white-space: nowrap; margin: 0 !important; font-size: 14px;" class="chip"
                                    :class="corStatus(os.status)">
                                    {{ os.status == 'Pendente' ? 'A iniciar' : os.status }}</span>
                            </div>
                        </td>
                        <td @click.stop>
                            <i class="bi-trash-fill" title="Excluir item" @click="excluirOs(os.id)"></i>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import serviceOsTablets from '@/services/serviceOsTablets';

export default {
    data() {
        return {
            listaOS: null,
        }
    },
    mounted() {
        this.getOS();
    },
    methods: {
        formatarData(data) {
            if (!data) return '-';
            const [ano, mes, dia] = data.split('-');
            return `${dia}/${mes}/${ano}`;
        },
        verOs(id) {
            this.$router.push({ name: 'visualizacaoOsTablets', params: { id: id } })
        },
        async excluirOs(id) {
            const confirmar = confirm('Tem certeza que deseja excluir esta OS?');
            if (!confirmar) return;
            await serviceOsTablets.crudOS('delete', null, id);
            this.listaOS = this.listaOS.filter(os => os.id != id)
        },
        async getOS() {
            var response = await serviceOsTablets.crudOS('get');
            this.listaOS = response.reverse()
        },
        diasParaFim(status, dtFimPrevisto) {
            var response = serviceOsTablets.diasParaFim(status, dtFimPrevisto);
            return response
        },
        corStatus(cor) {
            switch (cor) {
                case 'Em andamento':
                    // return 'var(--cor-ok)';
                    return 'bg-ok';
                case 'Concluído':
                    // return 'var(--cor-sucesso)';
                    return 'bg-sucesso';
                default:
                    // return '#FFA500';
                    return 'bg-alerta';
            }
        },
    },
}
</script>

<style scoped>
.bi-trash-fill {
    color: var(--cor-erro);
    font-size: 16px;
    visibility: hidden;
    cursor: pointer;
    transition: all 100ms linear;
}

.bi-trash-fill:hover {
    font-size: 18px
}

tr:hover {
    .bi-trash-fill {
        visibility: visible;
    }
}
</style>